module.exports = __webpack_public_path__ + "img/disperse.a5129a8e.svg";